var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHandHoldingHeart = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "hand-holding-heart",
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.958,
    height: 39.452,
    viewBox: "0 0 44.958 39.452",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4502",
    "data-name": "Path 4502",
    d: "M143.571,8.294a6.022,6.022,0,0,0,0,8.43l7.93,8.055a2.469,2.469,0,0,0,3.512,0l7.93-8.055a6.022,6.022,0,0,0,0-8.43,5.814,5.814,0,0,0-8.3,0l-1.382,1.4-1.382-1.4a5.814,5.814,0,0,0-8.3,0Z",
    transform: "translate(-130.778 -6.55)",
    fill: "#888",
    opacity: 0.403
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4503",
    "data-name": "Path 4503",
    d: "M43.686,325.635a3.121,3.121,0,0,0-3.7-5.027l-9.343,6.884H21.23a1.249,1.249,0,1,1,0-2.5h6.244a2.5,2.5,0,1,0,0-5H15.119a10.017,10.017,0,0,0-6.244,2.185L5.37,325H2.5a2.5,2.5,0,0,0-2.5,2.5v5a2.5,2.5,0,0,0,2.5,2.5H27.514a10.642,10.642,0,0,0,6.3-2.068l9.881-7.282Zm-28.575-.648a.039.039,0,1,1-.022-.042A.039.039,0,0,1,15.111,324.988Z",
    transform: "translate(0 -295.534)",
    fill: "#0d47a1"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHandHoldingHeart);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/hand-holding-heart.1873721a2cdbce6694d581483ce77321.svg";